module.exports = __webpack_public_path__ + "img/havefun_title_jp.710a0fb5.jpg";